import { idtype, pageLink } from "querypieces";

export default `
...on pageBuilder_navBlockMatrix_BlockType {
	${idtype}
	navBlockMatrix {
	  ...on navBlock_Entry {
    ${idtype}
		cardDescription
      ${pageLink}
      }
    }
  }
`
